// extracted by mini-css-extract-plugin
export default {"background":"styles-module--background--db709","section":"styles-module--section--6b291","short":"styles-module--short--6c3cf"};